import React, { useContext, useState } from "react";
import Container from "../Container";
import styles from "./index.module.scss";
import { Dropdown, Button } from "react-bootstrap";
import { AuthContext } from "../../providers/AuthProvider";
import { SettingsContext } from "../../providers/SettingsProvider";
import { getDefaultPrivateLeagueId, isLoggedIn } from "../../helpers/user";
import { useNavigate, useLocation } from "react-router-dom";
import { tgLink } from "../../constants";
import Support from "../../modals/Support";
import MobileMenu from "../MobileMenu";
import { ReactComponent as Puma } from "../../svgs/puma.svg";

const Header = () => {
  const [supportPopup, setSupportPopup] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const { user } = useContext(AuthContext);
  const { season } = useContext(SettingsContext);
  const navigate = useNavigate();
  const isAdmin = Boolean(user?.me?.isAdmin);
  const location = useLocation();

  const showPopup = () => {
    setSupportPopup(true);
  };

  const onHidePopup = () => {
    setSupportPopup(false);
  };

  const onAppLogoClick = () => {
    if (
      [
        "/maintenance",
        "/support",
        "/administration",
        "/access-denied",
      ].includes(location.pathname)
    ) {
      window.location.href = "/home";
    } else {
      navigate("/home");
    }
  };

  const onPartnerLogoClick = (type) => {
    switch (type) {
      case "upl":
        window.open("https://upl.ua", "_blank");
        break;
      case "kyivstar":
        window.open("https://tv.kyivstar.ua", "_blank");
        break;
      case "puma":
        window.open("https://ua.puma.com/uk", "_blank");
        break;
      default:
        return;
    }
  };

  const favTeamId = user?.me?.favTeamId || 85465;
  const defaultPrivateLeagueId = getDefaultPrivateLeagueId(
    user?.me?.privateLeagues
  );

  return (
    <header className={styles.header}>
      <Container>
        <div className={styles.headerCnt}>
          <img
            className={styles.logo}
            src="/logo.svg"
            alt=""
            onClick={onAppLogoClick}
          />

          {isLoggedIn() ? (
            <div className={styles.rightSide}>
              <div className={styles.partnerCnt}>
                <span className={styles.pcaption}>Наші партнери</span>
                <img
                  className={styles.plogo}
                  style={{ paddingLeft: 0 }}
                  src="/upl.png"
                  alt=""
                  onClick={() => onPartnerLogoClick("upl")}
                />
                <div className={styles.divider}></div>
                <img
                  className={styles.plogo}
                  src="/kyivstar.webp"
                  alt=""
                  onClick={() => onPartnerLogoClick("kyivstar")}
                />
                <div className={styles.divider}></div>

                <Puma
                  className={styles.plogo}
                  height={25}
                  width={25}
                  style={{ paddingRight: 0, boxSizing: "content-box" }}
                  onClick={() => onPartnerLogoClick("puma")}
                />
              </div>

              <div
                className={styles.hamburger}
                onClick={() => setMobileMenu(true)}
              >
                <i className="bi bi-list" style={{ fontSize: 36 }}></i>
              </div>

              <Dropdown className={styles.dropdown}>
                <Dropdown.Toggle variant="success" id="dropdown-menu">
                  <i
                    style={{ fontSize: 18 }}
                    className="bi bi-menu-button-wide"
                  ></i>
                </Dropdown.Toggle>

                <Dropdown.Menu className={styles.menu}>
                  {isAdmin && (
                    <>
                      <Dropdown.Item
                        onClick={() => navigate("/administration")}
                      >
                        <i className="bi bi-people-fill"></i>&nbsp;Адмінка
                      </Dropdown.Item>
                      <Dropdown.Divider />
                    </>
                  )}
                  <Dropdown.Item
                    onClick={() => navigate(`/leagues/${favTeamId}`)}
                  >
                    <i className="bi bi-list-task"></i>&nbsp;Клубні ліги
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() =>
                      navigate(`/private-leagues/${defaultPrivateLeagueId}`)
                    }
                  >
                    <i className="bi bi-incognito"></i>&nbsp;Приватні ліги
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => navigate("/stats")}>
                    <i className="bi bi-pie-chart"></i>&nbsp;Центр статистики
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => navigate(`/archived/${season - 1}`)}
                  >
                    <i className="bi bi-archive"></i>&nbsp;Архів
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={() => navigate("/rules")}>
                    <i className="bi bi-paperclip"></i>&nbsp;Правила гри
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => navigate("/terms-of-service")}>
                    <i className="bi bi-file-check"></i>&nbsp;Угода користувача
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => navigate("/privacy-policy")}>
                    <i className="bi bi-cookie"></i>&nbsp;Використання cookies
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={() => window.open(tgLink, "_blank")}>
                    <i className="bi bi-telegram"></i>&nbsp;Офіційний канал
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => showPopup()}>
                    <i className="bi bi-headset"></i>&nbsp;Техпідтримка
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={() => navigate("/logout")}>
                    <i className="bi bi-box-arrow-right"></i>&nbsp;Вийти
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          ) : (
            <Button
              className={styles.white}
              variant="link"
              onClick={() => navigate("/login")}
            >
              Увійти
            </Button>
          )}
        </div>
      </Container>
      <Support show={supportPopup} onHide={onHidePopup} />
      <MobileMenu
        show={mobileMenu}
        handleClose={() => setMobileMenu(false)}
        showSupportPopup={showPopup}
      />
    </header>
  );
};

export default Header;
